import styled from 'styled-components';
import { locations } from '../../../other/constants'

import { Text } from '../../../components/core';
import MenuItems from '../components/MenuItems'
import LocationMenuItem from './LocationMenuItem';
import { createRef, useEffect, useState } from 'react';

const Container = styled.div`
  height: ${window.innerHeight}px;
  width: 361px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 11;
`;

const Header = styled.div`
  width: 100%;
  height: 145px;
  position: relative;

  p {
    position: absolute;
    bottom: 20px;
    right: 30px;
    text-align: right;
  }
`;

const MenuItemsContainer = styled.div`
  position: relative;
  height: ${window.innerHeight - 125}px;
  overflow-y: scroll;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

const Overlay = styled.div`
    position:absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: 0px;
    z-index: 11;
    background-color: rgba(0, 0, 0, .25);
`

const ArrowWrap = styled.div`
  position: absolute;
  bottom: 15px;
  z-index: 11;
  ${({ left }: { left: boolean }) => left ? 'left' : 'right'}: 125px;
  cursor: pointer;
`

export const Arrow = (props: any) => (
  <ArrowWrap className='fadeIn' {...props}>
    <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <circle cx="26.5" cy="26.5" r="22.5" fill="white" fillOpacity="0.8" />
        <path d="M36.43 20.0715L26.9016 29.5083L17.3733 20.0715L14.4463 22.9767L26.9016 35.3394L39.357 22.9767L36.43 20.0715Z" fill="#3A499C" />
      </g>
      <defs>
        <filter id="filter0_d" x="0" y="0" width="53" height="53" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  </ArrowWrap>
)

type Props = {
  selectLocation: (arg0: string) => void
  close: () => void
}

export function useArrow(left?: boolean) {
  const BREAKPOINT = left ? 10 : 100
  const [scrolledTop, setScrolledTop] = useState(false)
  const refEl = createRef<HTMLDivElement>()

  useEffect(() => {
    if (refEl.current)
      setScrolledTop(refEl.current?.scrollHeight > refEl.current?.clientHeight)
  }, [])

  const onScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    if ((refEl.current?.scrollTop || 0) > BREAKPOINT && scrolledTop) setScrolledTop(false)
    else if ((refEl.current?.scrollTop || 0) <= BREAKPOINT && !scrolledTop) setScrolledTop(true)
  }

  const onClick = () => {
    refEl.current?.scrollHeight && refEl.current?.scrollTo({
      top: refEl.current?.scrollHeight,
      behavior: 'smooth'
    })
  }

  return {
    onScroll,
    onClick,
    refEl,
    scrolledTop
  }
}

const LocationsMenu = ({ selectLocation, close }: Props) => {
  const { refEl, onScroll, onClick, scrolledTop } = useArrow()
  return (
    <>
      <Overlay onClick={close} />
      <Container>
        <Header>
          <Text variant='Header2'>LOCATION LIST</Text>
        </Header>
        <MenuItemsContainer ref={refEl} onScroll={onScroll}>
          <MenuItems
            position='right'
            items={
              Object.keys(locations).map(location => {
                return (
                  <LocationMenuItem
                    location={location}
                    onClick={() => selectLocation(location)}
                  />
                )
              })
            }
          />
          {
            scrolledTop && <Arrow onClick={onclick} />}
        </MenuItemsContainer>
      </Container>
    </>
  )
};

export default LocationsMenu;